import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import Slide from '@material-ui/core/Slide';
import MuiSnackbar from '@material-ui/core/Snackbar';
import { combineClasses, styled, useThemeProps, } from '../../foundation';
import { useUnmountPortalHandler } from '../PortalHost';
import { RcSnackbarContent } from './SnackbarContent';
import { SnackbarStyle } from './styles';
import { RcSnackbarClasses } from './utils';
import { HasPortalParentProvider } from '../PortalHost/context/HasPortalParentContext';
var _RcSnackbar = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcSnackbar' });
    var classesProp = props.classes, size = props.size, type = props.type, message = props.message, action = props.action, ContentProps = props.ContentProps, children = props.children, TransitionPropsProp = props.TransitionProps, rest = __rest(props, ["classes", "size", "type", "message", "action", "ContentProps", "children", "TransitionProps"]);
    var classes = useMemo(function () { return combineClasses(RcSnackbarClasses, classesProp); }, [classesProp]);
    var onExited = useUnmountPortalHandler(TransitionPropsProp === null || TransitionPropsProp === void 0 ? void 0 : TransitionPropsProp.onExited);
    var TransitionProps = __assign(__assign({}, TransitionPropsProp), { onExited: onExited });
    return (React.createElement(HasPortalParentProvider, null,
        React.createElement(MuiSnackbar, __assign({ ref: ref, classes: classes, TransitionProps: TransitionProps }, rest), children || (React.createElement(RcSnackbarContent, __assign({ size: size, type: type, message: message, action: action }, ContentProps))))));
});
var RcSnackbar = styled(_RcSnackbar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), SnackbarStyle);
RcSnackbar.defaultProps = {
    TransitionComponent: Slide,
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
};
RcSnackbar.displayName = 'RcSnackbar';
export { RcSnackbar };
var templateObject_1;
